if (!customElements.get('popup-newsletter')) {
  class PopupNewsletter extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('.popup-newsletter__dialog');
      this.form = this.querySelector('.popup-newsletter__form');
      this.submitButton = this.form?.querySelector('[data-popup-newsletter-submit]');
      this.errorMessage = this.querySelector('[data-popup-newsletter-error]');
      this.successPanel = this.querySelector('[data-popup-newsletter-success]');
      this.closeButton = this.querySelector('[data-popup-newsletter-close]');
      this.footer = document.querySelector('.section-footer');
      this.storageKey = `popup-newsletter-${this.dataset.sectionId}-dismissed`;
      this.scrollStorageKey = `popup-newsletter-${this.dataset.sectionId}-scroll-position`;
      this.resultId = this.dataset.resultId;
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleClose = this.close.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleViewportChange = this.handleViewportChange.bind(this);
      this.closeButton?.addEventListener('click', this.handleClose);
      this.form?.addEventListener('submit', this.handleSubmit);
      document.addEventListener('keydown', this.handleKeydown);
      window.addEventListener('scroll', this.handleViewportChange, { passive: true });
      window.addEventListener('resize', this.handleViewportChange);
      this.initDraggable();

      const isEditorMode = this.dataset.editorMode === 'true';
      const isDismissed = !isEditorMode && this.wasClosed();

      if (this.handleReturnedSubmission()) {
        return;
      }

      if (!isDismissed) {
        this.revealTimer = window.setTimeout(() => this.open(), isEditorMode ? 0 : Number(this.dataset.delay || 0));
      }
    }

    disconnectedCallback() {
      this.closeButton?.removeEventListener('click', this.handleClose);
      this.form?.removeEventListener('submit', this.handleSubmit);
      document.removeEventListener('keydown', this.handleKeydown);
      window.removeEventListener('scroll', this.handleViewportChange);
      window.removeEventListener('resize', this.handleViewportChange);
      window.cancelAnimationFrame(this.openFrame);
      window.cancelAnimationFrame(this.visibleFrame);
      window.cancelAnimationFrame(this.viewportFrame);
      window.clearTimeout(this.revealTimer);
      window.clearTimeout(this.hideTimer);

      if (this.dialog && window.jQuery?.fn?.draggable && window.jQuery(this.dialog).hasClass('ui-draggable')) {
        window.jQuery(this.dialog).draggable('destroy');
      }
    }

    initDraggable() {
      if (!this.dialog || !window.jQuery?.fn?.draggable) return;

      window.jQuery(this.dialog).draggable({
        containment: 'window',
        cancel: 'input, button, a, label',
        scroll: false,
        drag: () => this.updateFooterVisibility(),
        stop: () => this.updateFooterVisibility()
      });
    }

    handleViewportChange() {
      window.cancelAnimationFrame(this.viewportFrame);
      this.viewportFrame = window.requestAnimationFrame(() => this.updateFooterVisibility());
    }

    updateFooterVisibility() {
      if (!this.footer || !this.dialog || this.hidden) return;

      const footerRect = this.footer.getBoundingClientRect();
      const popupRect = this.dialog.getBoundingClientRect();
      const overlapsFooter = popupRect.bottom > footerRect.top && popupRect.top < footerRect.bottom;

      this.classList.toggle('is-footer-overlap', overlapsFooter);
    }

    wasClosed() {
      try {
        return window.sessionStorage.getItem(this.storageKey) === 'true';
      } catch (error) {
        return false;
      }
    }

    rememberClosed() {
      try {
        window.sessionStorage.setItem(this.storageKey, 'true');
      } catch (error) {
        return;
      }
    }

    handleSubmit() {
      if (!this.form) return;

      try {
        window.sessionStorage.setItem(this.scrollStorageKey, String(window.scrollY));
      } catch (error) {
        // The native Shopify submission must continue even when storage is unavailable.
      }

      const action = new URL(this.form.action, window.location.origin);
      action.hash = this.resultId;
      this.form.action = action.toString();
    }

    handleReturnedSubmission() {
      if (!this.resultId || window.location.hash !== `#${this.resultId}`) return false;

      const returnedSuccess = this.form?.querySelector('[data-popup-newsletter-response-success]');
      const returnedError = this.form?.querySelector('[data-popup-newsletter-response-error]');

      document.getElementById('ContactFooter-success')?.setAttribute('hidden', 'hidden');
      document.getElementById('ContactFooter-error')?.setAttribute('hidden', 'hidden');

      this.open();

      if (returnedSuccess) {
        this.showSuccess();
      } else if (returnedError) {
        this.showError(returnedError.textContent.trim());
      }

      this.restoreScrollPosition();
      window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
      return true;
    }

    restoreScrollPosition() {
      try {
        const storedScrollPosition = window.sessionStorage.getItem(this.scrollStorageKey);
        const scrollPosition = Number(storedScrollPosition);

        if (storedScrollPosition !== null && Number.isFinite(scrollPosition)) {
          window.requestAnimationFrame(() => window.scrollTo(0, scrollPosition));
        }

        window.sessionStorage.removeItem(this.scrollStorageKey);
      } catch (error) {
        return;
      }
    }

    showSuccess() {
      this.form.reset();
      this.errorMessage.hidden = true;
      this.successPanel.hidden = false;
      this.dialog.classList.add('has-success');
    }

    showError(message) {
      this.errorMessage.textContent = message;
      this.errorMessage.hidden = false;
    }

    open() {
      this.hidden = false;
      this.openFrame = window.requestAnimationFrame(() => {
        this.visibleFrame = window.requestAnimationFrame(() => {
          this.classList.add('is-visible');
          this.updateFooterVisibility();
        });
      });
    }

    close() {
      window.clearTimeout(this.revealTimer);
      this.classList.remove('is-visible');
      this.rememberClosed();
      this.hideTimer = window.setTimeout(() => { this.hidden = true; }, 300);
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.classList.contains('is-visible')) this.close();
    }
  }

  customElements.define('popup-newsletter', PopupNewsletter);
}
